/**
 * ### AutoOrderQuantityWriteSourceEnum
 * Identifies which frontend path produced a `setAOQuantities` Firestore write.
 *
 * @enum {string}
 */
export enum AutoOrderQuantityWriteSourceEnum {
  AUTOSAVE = 'autosave',
  PREPARE = 'prepare',
  RETRY = 'retry',
}

/**
 * ### AutoOrderQuantityWriteResultEnum
 * Outcome of a `setAOQuantities` Firestore write, logged before and after the call.
 *
 * @enum {string}
 */
export enum AutoOrderQuantityWriteResultEnum {
  FAILURE = 'failure',
  STARTED = 'started',
  SUCCESS = 'success',
}
